module.exports = __webpack_public_path__ + "img/3-2.70aea488.png";